export const COUNTRY_CALLING_CODES = [
    // France et Réunion en premier
    { name: 'France', callingCode: '+33', flag: '\u{1F1EB}\u{1F1F7}', iso2: 'FR', nsnLength: 9 },
    {
        name: 'Île de la Réunion',
        callingCode: '+262',
        flag: '\u{1F1F7}\u{1F1EA}',
        iso2: 'RE',
        nsnLength: 9,
    },
    // Reste par ordre alphabétique (noms en français)
    { name: 'Afghanistan', callingCode: '+93', flag: '\u{1F1E6}\u{1F1EB}', iso2: 'AF', nsnLength: 9 },
    {
        name: 'Afrique du Sud',
        callingCode: '+27',
        flag: '\u{1F1FF}\u{1F1E6}',
        iso2: 'ZA',
        nsnLength: 9,
    },
    { name: 'Albanie', callingCode: '+355', flag: '\u{1F1E6}\u{1F1F1}', iso2: 'AL', nsnLength: 9 },
    { name: 'Algérie', callingCode: '+213', flag: '\u{1F1E9}\u{1F1FF}', iso2: 'DZ', nsnLength: 9 },
    { name: 'Allemagne', callingCode: '+49', flag: '\u{1F1E9}\u{1F1EA}', iso2: 'DE', nsnLength: 11 },
    { name: 'Andorre', callingCode: '+376', flag: '\u{1F1E6}\u{1F1E9}', iso2: 'AD', nsnLength: 6 },
    { name: 'Angola', callingCode: '+244', flag: '\u{1F1E6}\u{1F1F4}', iso2: 'AO', nsnLength: 9 },
    {
        name: 'Antigua-et-Barbuda',
        callingCode: '+1268',
        flag: '\u{1F1E6}\u{1F1EC}',
        iso2: 'AG',
        nsnLength: 7,
    },
    {
        name: 'Arabie saoudite',
        callingCode: '+966',
        flag: '\u{1F1F8}\u{1F1E6}',
        iso2: 'SA',
        nsnLength: 9,
    },
    { name: 'Argentine', callingCode: '+54', flag: '\u{1F1E6}\u{1F1F7}', iso2: 'AR', nsnLength: 10 },
    { name: 'Arménie', callingCode: '+374', flag: '\u{1F1E6}\u{1F1F2}', iso2: 'AM', nsnLength: 8 },
    { name: 'Australie', callingCode: '+61', flag: '\u{1F1E6}\u{1F1FA}', iso2: 'AU', nsnLength: 9 },
    { name: 'Autriche', callingCode: '+43', flag: '\u{1F1E6}\u{1F1F9}', iso2: 'AT', nsnLength: 10 },
    {
        name: 'Azerbaïdjan',
        callingCode: '+994',
        flag: '\u{1F1E6}\u{1F1FF}',
        iso2: 'AZ',
        nsnLength: 9,
    },
    { name: 'Bahamas', callingCode: '+1242', flag: '\u{1F1E7}\u{1F1F8}', iso2: 'BS', nsnLength: 7 },
    { name: 'Bahreïn', callingCode: '+973', flag: '\u{1F1E7}\u{1F1ED}', iso2: 'BH', nsnLength: 8 },
    {
        name: 'Bangladesh',
        callingCode: '+880',
        flag: '\u{1F1E7}\u{1F1E9}',
        iso2: 'BD',
        nsnLength: 10,
    },
    { name: 'Barbade', callingCode: '+1246', flag: '\u{1F1E7}\u{1F1E7}', iso2: 'BB', nsnLength: 7 },
    { name: 'Belgique', callingCode: '+32', flag: '\u{1F1E7}\u{1F1EA}', iso2: 'BE', nsnLength: 9 },
    { name: 'Belize', callingCode: '+501', flag: '\u{1F1E7}\u{1F1FF}', iso2: 'BZ', nsnLength: 7 },
    { name: 'Bénin', callingCode: '+229', flag: '\u{1F1E7}\u{1F1EF}', iso2: 'BJ', nsnLength: 8 },
    { name: 'Bhoutan', callingCode: '+975', flag: '\u{1F1E7}\u{1F1F9}', iso2: 'BT', nsnLength: 8 },
    {
        name: 'Biélorussie',
        callingCode: '+375',
        flag: '\u{1F1E7}\u{1F1FE}',
        iso2: 'BY',
        nsnLength: 10,
    },
    { name: 'Birmanie', callingCode: '+95', flag: '\u{1F1F2}\u{1F1F2}', iso2: 'MM', nsnLength: 10 },
    { name: 'Bolivie', callingCode: '+591', flag: '\u{1F1E7}\u{1F1F4}', iso2: 'BO', nsnLength: 8 },
    {
        name: 'Bosnie-Herzégovine',
        callingCode: '+387',
        flag: '\u{1F1E7}\u{1F1E6}',
        iso2: 'BA',
        nsnLength: 8,
    },
    { name: 'Botswana', callingCode: '+267', flag: '\u{1F1E7}\u{1F1FC}', iso2: 'BW', nsnLength: 8 },
    { name: 'Brésil', callingCode: '+55', flag: '\u{1F1E7}\u{1F1F7}', iso2: 'BR', nsnLength: 11 },
    { name: 'Brunei', callingCode: '+673', flag: '\u{1F1E7}\u{1F1F3}', iso2: 'BN', nsnLength: 7 },
    { name: 'Bulgarie', callingCode: '+359', flag: '\u{1F1E7}\u{1F1EC}', iso2: 'BG', nsnLength: 9 },
    {
        name: 'Burkina Faso',
        callingCode: '+226',
        flag: '\u{1F1E7}\u{1F1EB}',
        iso2: 'BF',
        nsnLength: 8,
    },
    { name: 'Burundi', callingCode: '+257', flag: '\u{1F1E7}\u{1F1EE}', iso2: 'BI', nsnLength: 8 },
    { name: 'Cambodge', callingCode: '+855', flag: '\u{1F1F0}\u{1F1ED}', iso2: 'KH', nsnLength: 9 },
    { name: 'Cameroun', callingCode: '+237', flag: '\u{1F1E8}\u{1F1F2}', iso2: 'CM', nsnLength: 9 },
    { name: 'Canada', callingCode: '+1', flag: '\u{1F1E8}\u{1F1E6}', iso2: 'CA', nsnLength: 10 },
    { name: 'Cap-Vert', callingCode: '+238', flag: '\u{1F1E8}\u{1F1FB}', iso2: 'CV', nsnLength: 7 },
    {
        name: 'Centrafrique',
        callingCode: '+236',
        flag: '\u{1F1E8}\u{1F1EB}',
        iso2: 'CF',
        nsnLength: 8,
    },
    { name: 'Chili', callingCode: '+56', flag: '\u{1F1E8}\u{1F1F1}', iso2: 'CL', nsnLength: 9 },
    { name: 'Chine', callingCode: '+86', flag: '\u{1F1E8}\u{1F1F3}', iso2: 'CN', nsnLength: 11 },
    { name: 'Chypre', callingCode: '+357', flag: '\u{1F1E8}\u{1F1FE}', iso2: 'CY', nsnLength: 8 },
    { name: 'Colombie', callingCode: '+57', flag: '\u{1F1E8}\u{1F1F4}', iso2: 'CO', nsnLength: 10 },
    { name: 'Comores', callingCode: '+269', flag: '\u{1F1F0}\u{1F1F2}', iso2: 'KM', nsnLength: 7 },
    {
        name: 'Congo-Brazzaville',
        callingCode: '+242',
        flag: '\u{1F1E8}\u{1F1EC}',
        iso2: 'CG',
        nsnLength: 9,
    },
    {
        name: 'Congo-Kinshasa',
        callingCode: '+243',
        flag: '\u{1F1E8}\u{1F1E9}',
        iso2: 'CD',
        nsnLength: 9,
    },
    {
        name: 'Corée du Nord',
        callingCode: '+850',
        flag: '\u{1F1F0}\u{1F1F5}',
        iso2: 'KP',
        nsnLength: 10,
    },
    {
        name: 'Corée du Sud',
        callingCode: '+82',
        flag: '\u{1F1F0}\u{1F1F7}',
        iso2: 'KR',
        nsnLength: 10,
    },
    { name: 'Costa Rica', callingCode: '+506', flag: '\u{1F1E8}\u{1F1F7}', iso2: 'CR', nsnLength: 8 },
    {
        name: "Côte d'Ivoire",
        callingCode: '+225',
        flag: '\u{1F1E8}\u{1F1EE}',
        iso2: 'CI',
        nsnLength: 10,
    },
    { name: 'Croatie', callingCode: '+385', flag: '\u{1F1ED}\u{1F1F7}', iso2: 'HR', nsnLength: 9 },
    { name: 'Cuba', callingCode: '+53', flag: '\u{1F1E8}\u{1F1FA}', iso2: 'CU', nsnLength: 8 },
    { name: 'Danemark', callingCode: '+45', flag: '\u{1F1E9}\u{1F1F0}', iso2: 'DK', nsnLength: 8 },
    { name: 'Djibouti', callingCode: '+253', flag: '\u{1F1E9}\u{1F1EF}', iso2: 'DJ', nsnLength: 8 },
    { name: 'Dominique', callingCode: '+1767', flag: '\u{1F1E9}\u{1F1F2}', iso2: 'DM', nsnLength: 7 },
    { name: 'Égypte', callingCode: '+20', flag: '\u{1F1EA}\u{1F1EC}', iso2: 'EG', nsnLength: 10 },
    {
        name: 'Émirats arabes unis',
        callingCode: '+971',
        flag: '\u{1F1E6}\u{1F1EA}',
        iso2: 'AE',
        nsnLength: 9,
    },
    { name: 'Équateur', callingCode: '+593', flag: '\u{1F1EA}\u{1F1E8}', iso2: 'EC', nsnLength: 9 },
    { name: 'Érythrée', callingCode: '+291', flag: '\u{1F1EA}\u{1F1F7}', iso2: 'ER', nsnLength: 7 },
    { name: 'Espagne', callingCode: '+34', flag: '\u{1F1EA}\u{1F1F8}', iso2: 'ES', nsnLength: 9 },
    { name: 'Estonie', callingCode: '+372', flag: '\u{1F1EA}\u{1F1EA}', iso2: 'EE', nsnLength: 8 },
    { name: 'Eswatini', callingCode: '+268', flag: '\u{1F1F8}\u{1F1FF}', iso2: 'SZ', nsnLength: 8 },
    { name: 'États-Unis', callingCode: '+1', flag: '\u{1F1FA}\u{1F1F8}', iso2: 'US', nsnLength: 10 },
    { name: 'Éthiopie', callingCode: '+251', flag: '\u{1F1EA}\u{1F1F9}', iso2: 'ET', nsnLength: 9 },
    { name: 'Fidji', callingCode: '+679', flag: '\u{1F1EB}\u{1F1EF}', iso2: 'FJ', nsnLength: 7 },
    { name: 'Finlande', callingCode: '+358', flag: '\u{1F1EB}\u{1F1EE}', iso2: 'FI', nsnLength: 10 },
    { name: 'Gabon', callingCode: '+241', flag: '\u{1F1EC}\u{1F1E6}', iso2: 'GA', nsnLength: 7 },
    { name: 'Gambie', callingCode: '+220', flag: '\u{1F1EC}\u{1F1F2}', iso2: 'GM', nsnLength: 7 },
    { name: 'Géorgie', callingCode: '+995', flag: '\u{1F1EC}\u{1F1EA}', iso2: 'GE', nsnLength: 9 },
    { name: 'Ghana', callingCode: '+233', flag: '\u{1F1EC}\u{1F1ED}', iso2: 'GH', nsnLength: 9 },
    { name: 'Grèce', callingCode: '+30', flag: '\u{1F1EC}\u{1F1F7}', iso2: 'GR', nsnLength: 10 },
    { name: 'Grenade', callingCode: '+1473', flag: '\u{1F1EC}\u{1F1E9}', iso2: 'GD', nsnLength: 7 },
    { name: 'Guatemala', callingCode: '+502', flag: '\u{1F1EC}\u{1F1F9}', iso2: 'GT', nsnLength: 8 },
    { name: 'Guinée', callingCode: '+224', flag: '\u{1F1EC}\u{1F1F3}', iso2: 'GN', nsnLength: 9 },
    {
        name: 'Guinée équatoriale',
        callingCode: '+240',
        flag: '\u{1F1EC}\u{1F1F6}',
        iso2: 'GQ',
        nsnLength: 9,
    },
    {
        name: 'Guinée-Bissau',
        callingCode: '+245',
        flag: '\u{1F1EC}\u{1F1FC}',
        iso2: 'GW',
        nsnLength: 9,
    },
    { name: 'Guyana', callingCode: '+592', flag: '\u{1F1EC}\u{1F1FE}', iso2: 'GY', nsnLength: 7 },
    { name: 'Haïti', callingCode: '+509', flag: '\u{1F1ED}\u{1F1F9}', iso2: 'HT', nsnLength: 8 },
    { name: 'Honduras', callingCode: '+504', flag: '\u{1F1ED}\u{1F1F3}', iso2: 'HN', nsnLength: 8 },
    { name: 'Hongrie', callingCode: '+36', flag: '\u{1F1ED}\u{1F1FA}', iso2: 'HU', nsnLength: 9 },
    { name: 'Inde', callingCode: '+91', flag: '\u{1F1EE}\u{1F1F3}', iso2: 'IN', nsnLength: 10 },
    { name: 'Indonésie', callingCode: '+62', flag: '\u{1F1EE}\u{1F1E9}', iso2: 'ID', nsnLength: 11 },
    { name: 'Irak', callingCode: '+964', flag: '\u{1F1EE}\u{1F1F6}', iso2: 'IQ', nsnLength: 10 },
    { name: 'Iran', callingCode: '+98', flag: '\u{1F1EE}\u{1F1F7}', iso2: 'IR', nsnLength: 10 },
    { name: 'Irlande', callingCode: '+353', flag: '\u{1F1EE}\u{1F1EA}', iso2: 'IE', nsnLength: 9 },
    { name: 'Islande', callingCode: '+354', flag: '\u{1F1EE}\u{1F1F8}', iso2: 'IS', nsnLength: 7 },
    { name: 'Israël', callingCode: '+972', flag: '\u{1F1EE}\u{1F1F1}', iso2: 'IL', nsnLength: 9 },
    { name: 'Italie', callingCode: '+39', flag: '\u{1F1EE}\u{1F1F9}', iso2: 'IT', nsnLength: 10 },
    { name: 'Jamaïque', callingCode: '+1876', flag: '\u{1F1EF}\u{1F1F2}', iso2: 'JM', nsnLength: 7 },
    { name: 'Japon', callingCode: '+81', flag: '\u{1F1EF}\u{1F1F5}', iso2: 'JP', nsnLength: 10 },
    { name: 'Jordanie', callingCode: '+962', flag: '\u{1F1EF}\u{1F1F4}', iso2: 'JO', nsnLength: 9 },
    { name: 'Kazakhstan', callingCode: '+7', flag: '\u{1F1F0}\u{1F1FF}', iso2: 'KZ', nsnLength: 10 },
    { name: 'Kenya', callingCode: '+254', flag: '\u{1F1F0}\u{1F1EA}', iso2: 'KE', nsnLength: 10 },
    {
        name: 'Kirghizistan',
        callingCode: '+996',
        flag: '\u{1F1F0}\u{1F1EC}',
        iso2: 'KG',
        nsnLength: 9,
    },
    { name: 'Kiribati', callingCode: '+686', flag: '\u{1F1F0}\u{1F1EE}', iso2: 'KI', nsnLength: 8 },
    { name: 'Koweït', callingCode: '+965', flag: '\u{1F1F0}\u{1F1FC}', iso2: 'KW', nsnLength: 8 },
    { name: 'Laos', callingCode: '+856', flag: '\u{1F1F1}\u{1F1E6}', iso2: 'LA', nsnLength: 10 },
    { name: 'Lesotho', callingCode: '+266', flag: '\u{1F1F1}\u{1F1F8}', iso2: 'LS', nsnLength: 8 },
    { name: 'Lettonie', callingCode: '+371', flag: '\u{1F1F1}\u{1F1FB}', iso2: 'LV', nsnLength: 8 },
    { name: 'Liban', callingCode: '+961', flag: '\u{1F1F1}\u{1F1E7}', iso2: 'LB', nsnLength: 8 },
    { name: 'Liberia', callingCode: '+231', flag: '\u{1F1F1}\u{1F1F7}', iso2: 'LR', nsnLength: 9 },
    { name: 'Libye', callingCode: '+218', flag: '\u{1F1F1}\u{1F1FE}', iso2: 'LY', nsnLength: 10 },
    {
        name: 'Liechtenstein',
        callingCode: '+423',
        flag: '\u{1F1F1}\u{1F1EE}',
        iso2: 'LI',
        nsnLength: 7,
    },
    { name: 'Lituanie', callingCode: '+370', flag: '\u{1F1F1}\u{1F1F9}', iso2: 'LT', nsnLength: 8 },
    { name: 'Luxembourg', callingCode: '+352', flag: '\u{1F1F1}\u{1F1FA}', iso2: 'LU', nsnLength: 9 },
    {
        name: 'Macédoine du Nord',
        callingCode: '+389',
        flag: '\u{1F1F2}\u{1F1F0}',
        iso2: 'MK',
        nsnLength: 8,
    },
    { name: 'Madagascar', callingCode: '+261', flag: '\u{1F1F2}\u{1F1EC}', iso2: 'MG', nsnLength: 9 },
    { name: 'Malaisie', callingCode: '+60', flag: '\u{1F1F2}\u{1F1FE}', iso2: 'MY', nsnLength: 10 },
    { name: 'Malawi', callingCode: '+265', flag: '\u{1F1F2}\u{1F1FC}', iso2: 'MW', nsnLength: 9 },
    { name: 'Maldives', callingCode: '+960', flag: '\u{1F1F2}\u{1F1FB}', iso2: 'MV', nsnLength: 7 },
    { name: 'Mali', callingCode: '+223', flag: '\u{1F1F2}\u{1F1F1}', iso2: 'ML', nsnLength: 8 },
    { name: 'Malte', callingCode: '+356', flag: '\u{1F1F2}\u{1F1F9}', iso2: 'MT', nsnLength: 8 },
    { name: 'Maroc', callingCode: '+212', flag: '\u{1F1F2}\u{1F1E6}', iso2: 'MA', nsnLength: 9 },
    { name: 'Maurice', callingCode: '+230', flag: '\u{1F1F2}\u{1F1FA}', iso2: 'MU', nsnLength: 8 },
    { name: 'Mauritanie', callingCode: '+222', flag: '\u{1F1F2}\u{1F1F7}', iso2: 'MR', nsnLength: 8 },
    { name: 'Mexique', callingCode: '+52', flag: '\u{1F1F2}\u{1F1FD}', iso2: 'MX', nsnLength: 10 },
    { name: 'Micronésie', callingCode: '+691', flag: '\u{1F1EB}\u{1F1F2}', iso2: 'FM', nsnLength: 7 },
    { name: 'Moldavie', callingCode: '+373', flag: '\u{1F1F2}\u{1F1E9}', iso2: 'MD', nsnLength: 8 },
    { name: 'Monaco', callingCode: '+377', flag: '\u{1F1F2}\u{1F1E8}', iso2: 'MC', nsnLength: 8 },
    { name: 'Mongolie', callingCode: '+976', flag: '\u{1F1F2}\u{1F1F3}', iso2: 'MN', nsnLength: 8 },
    { name: 'Monténégro', callingCode: '+382', flag: '\u{1F1F2}\u{1F1EA}', iso2: 'ME', nsnLength: 8 },
    { name: 'Mozambique', callingCode: '+258', flag: '\u{1F1F2}\u{1F1FF}', iso2: 'MZ', nsnLength: 9 },
    { name: 'Namibie', callingCode: '+264', flag: '\u{1F1F3}\u{1F1E6}', iso2: 'NA', nsnLength: 10 },
    { name: 'Nauru', callingCode: '+674', flag: '\u{1F1F3}\u{1F1F7}', iso2: 'NR', nsnLength: 7 },
    { name: 'Népal', callingCode: '+977', flag: '\u{1F1F3}\u{1F1F5}', iso2: 'NP', nsnLength: 10 },
    { name: 'Nicaragua', callingCode: '+505', flag: '\u{1F1F3}\u{1F1EE}', iso2: 'NI', nsnLength: 8 },
    { name: 'Niger', callingCode: '+227', flag: '\u{1F1F3}\u{1F1EA}', iso2: 'NE', nsnLength: 8 },
    { name: 'Nigeria', callingCode: '+234', flag: '\u{1F1F3}\u{1F1EC}', iso2: 'NG', nsnLength: 10 },
    { name: 'Norvège', callingCode: '+47', flag: '\u{1F1F3}\u{1F1F4}', iso2: 'NO', nsnLength: 8 },
    {
        name: 'Nouvelle-Zélande',
        callingCode: '+64',
        flag: '\u{1F1F3}\u{1F1FF}',
        iso2: 'NZ',
        nsnLength: 9,
    },
    { name: 'Oman', callingCode: '+968', flag: '\u{1F1F4}\u{1F1F2}', iso2: 'OM', nsnLength: 8 },
    { name: 'Ouganda', callingCode: '+256', flag: '\u{1F1FA}\u{1F1EC}', iso2: 'UG', nsnLength: 9 },
    {
        name: 'Ouzbékistan',
        callingCode: '+998',
        flag: '\u{1F1FA}\u{1F1FF}',
        iso2: 'UZ',
        nsnLength: 9,
    },
    { name: 'Pakistan', callingCode: '+92', flag: '\u{1F1F5}\u{1F1F0}', iso2: 'PK', nsnLength: 10 },
    { name: 'Palaos', callingCode: '+680', flag: '\u{1F1F5}\u{1F1FC}', iso2: 'PW', nsnLength: 7 },
    { name: 'Palestine', callingCode: '+970', flag: '\u{1F1F5}\u{1F1F8}', iso2: 'PS', nsnLength: 9 },
    { name: 'Panama', callingCode: '+507', flag: '\u{1F1F5}\u{1F1E6}', iso2: 'PA', nsnLength: 8 },
    {
        name: 'Papouasie-Nouvelle-Guinée',
        callingCode: '+675',
        flag: '\u{1F1F5}\u{1F1EC}',
        iso2: 'PG',
        nsnLength: 8,
    },
    { name: 'Paraguay', callingCode: '+595', flag: '\u{1F1F5}\u{1F1FE}', iso2: 'PY', nsnLength: 9 },
    { name: 'Pays-Bas', callingCode: '+31', flag: '\u{1F1F3}\u{1F1F1}', iso2: 'NL', nsnLength: 9 },
    { name: 'Pérou', callingCode: '+51', flag: '\u{1F1F5}\u{1F1EA}', iso2: 'PE', nsnLength: 9 },
    {
        name: 'Philippines',
        callingCode: '+63',
        flag: '\u{1F1F5}\u{1F1ED}',
        iso2: 'PH',
        nsnLength: 10,
    },
    { name: 'Pologne', callingCode: '+48', flag: '\u{1F1F5}\u{1F1F1}', iso2: 'PL', nsnLength: 9 },
    { name: 'Portugal', callingCode: '+351', flag: '\u{1F1F5}\u{1F1F9}', iso2: 'PT', nsnLength: 9 },
    { name: 'Qatar', callingCode: '+974', flag: '\u{1F1F6}\u{1F1E6}', iso2: 'QA', nsnLength: 8 },
    {
        name: 'République dominicaine',
        callingCode: '+1809',
        flag: '\u{1F1E9}\u{1F1F4}',
        iso2: 'DO',
        nsnLength: 7,
    },
    {
        name: 'République tchèque',
        callingCode: '+420',
        flag: '\u{1F1E8}\u{1F1FF}',
        iso2: 'CZ',
        nsnLength: 9,
    },
    { name: 'Roumanie', callingCode: '+40', flag: '\u{1F1F7}\u{1F1F4}', iso2: 'RO', nsnLength: 9 },
    {
        name: 'Royaume-Uni',
        callingCode: '+44',
        flag: '\u{1F1EC}\u{1F1E7}',
        iso2: 'GB',
        nsnLength: 10,
    },
    { name: 'Russie', callingCode: '+7', flag: '\u{1F1F7}\u{1F1FA}', iso2: 'RU', nsnLength: 10 },
    { name: 'Rwanda', callingCode: '+250', flag: '\u{1F1F7}\u{1F1FC}', iso2: 'RW', nsnLength: 9 },
    {
        name: 'Saint-Kitts-et-Nevis',
        callingCode: '+1869',
        flag: '\u{1F1F0}\u{1F1F3}',
        iso2: 'KN',
        nsnLength: 7,
    },
    {
        name: 'Saint-Vincent-et-les-Grenadines',
        callingCode: '+1784',
        flag: '\u{1F1FB}\u{1F1E8}',
        iso2: 'VC',
        nsnLength: 7,
    },
    {
        name: 'Sainte-Lucie',
        callingCode: '+1758',
        flag: '\u{1F1F1}\u{1F1E8}',
        iso2: 'LC',
        nsnLength: 7,
    },
    { name: 'Salomon', callingCode: '+677', flag: '\u{1F1F8}\u{1F1E7}', iso2: 'SB', nsnLength: 7 },
    { name: 'Salvador', callingCode: '+503', flag: '\u{1F1F8}\u{1F1FB}', iso2: 'SV', nsnLength: 8 },
    { name: 'Samoa', callingCode: '+685', flag: '\u{1F1FC}\u{1F1F8}', iso2: 'WS', nsnLength: 7 },
    {
        name: 'São Tomé-et-Príncipe',
        callingCode: '+239',
        flag: '\u{1F1F8}\u{1F1F9}',
        iso2: 'ST',
        nsnLength: 7,
    },
    { name: 'Sénégal', callingCode: '+221', flag: '\u{1F1F8}\u{1F1F3}', iso2: 'SN', nsnLength: 9 },
    { name: 'Serbie', callingCode: '+381', flag: '\u{1F1F7}\u{1F1F8}', iso2: 'RS', nsnLength: 9 },
    { name: 'Seychelles', callingCode: '+248', flag: '\u{1F1F8}\u{1F1E8}', iso2: 'SC', nsnLength: 7 },
    {
        name: 'Sierra Leone',
        callingCode: '+232',
        flag: '\u{1F1F8}\u{1F1F1}',
        iso2: 'SL',
        nsnLength: 8,
    },
    { name: 'Singapour', callingCode: '+65', flag: '\u{1F1F8}\u{1F1EC}', iso2: 'SG', nsnLength: 8 },
    { name: 'Slovaquie', callingCode: '+421', flag: '\u{1F1F8}\u{1F1F0}', iso2: 'SK', nsnLength: 9 },
    { name: 'Slovénie', callingCode: '+386', flag: '\u{1F1F8}\u{1F1EE}', iso2: 'SI', nsnLength: 8 },
    { name: 'Somalie', callingCode: '+252', flag: '\u{1F1F8}\u{1F1F4}', iso2: 'SO', nsnLength: 8 },
    { name: 'Soudan', callingCode: '+249', flag: '\u{1F1F8}\u{1F1E9}', iso2: 'SD', nsnLength: 9 },
    {
        name: 'Soudan du Sud',
        callingCode: '+211',
        flag: '\u{1F1F8}\u{1F1F8}',
        iso2: 'SS',
        nsnLength: 9,
    },
    { name: 'Sri Lanka', callingCode: '+94', flag: '\u{1F1F1}\u{1F1F0}', iso2: 'LK', nsnLength: 9 },
    { name: 'Suède', callingCode: '+46', flag: '\u{1F1F8}\u{1F1EA}', iso2: 'SE', nsnLength: 9 },
    { name: 'Suisse', callingCode: '+41', flag: '\u{1F1E8}\u{1F1ED}', iso2: 'CH', nsnLength: 9 },
    { name: 'Suriname', callingCode: '+597', flag: '\u{1F1F8}\u{1F1F7}', iso2: 'SR', nsnLength: 7 },
    { name: 'Syrie', callingCode: '+963', flag: '\u{1F1F8}\u{1F1FE}', iso2: 'SY', nsnLength: 9 },
    {
        name: 'Tadjikistan',
        callingCode: '+992',
        flag: '\u{1F1F9}\u{1F1EF}',
        iso2: 'TJ',
        nsnLength: 9,
    },
    { name: 'Tanzanie', callingCode: '+255', flag: '\u{1F1F9}\u{1F1FF}', iso2: 'TZ', nsnLength: 9 },
    { name: 'Tchad', callingCode: '+235', flag: '\u{1F1F9}\u{1F1E9}', iso2: 'TD', nsnLength: 8 },
    { name: 'Thaïlande', callingCode: '+66', flag: '\u{1F1F9}\u{1F1ED}', iso2: 'TH', nsnLength: 9 },
    {
        name: 'Timor oriental',
        callingCode: '+670',
        flag: '\u{1F1F9}\u{1F1F1}',
        iso2: 'TL',
        nsnLength: 8,
    },
    { name: 'Togo', callingCode: '+228', flag: '\u{1F1F9}\u{1F1EC}', iso2: 'TG', nsnLength: 8 },
    { name: 'Tonga', callingCode: '+676', flag: '\u{1F1F9}\u{1F1F4}', iso2: 'TO', nsnLength: 7 },
    {
        name: 'Trinité-et-Tobago',
        callingCode: '+1868',
        flag: '\u{1F1F9}\u{1F1F9}',
        iso2: 'TT',
        nsnLength: 7,
    },
    { name: 'Tunisie', callingCode: '+216', flag: '\u{1F1F9}\u{1F1F3}', iso2: 'TN', nsnLength: 8 },
    {
        name: 'Turkménistan',
        callingCode: '+993',
        flag: '\u{1F1F9}\u{1F1F2}',
        iso2: 'TM',
        nsnLength: 8,
    },
    { name: 'Turquie', callingCode: '+90', flag: '\u{1F1F9}\u{1F1F7}', iso2: 'TR', nsnLength: 10 },
    { name: 'Tuvalu', callingCode: '+688', flag: '\u{1F1F9}\u{1F1FB}', iso2: 'TV', nsnLength: 6 },
    { name: 'Ukraine', callingCode: '+380', flag: '\u{1F1FA}\u{1F1E6}', iso2: 'UA', nsnLength: 9 },
    { name: 'Uruguay', callingCode: '+598', flag: '\u{1F1FA}\u{1F1FE}', iso2: 'UY', nsnLength: 8 },
    { name: 'Vanuatu', callingCode: '+678', flag: '\u{1F1FB}\u{1F1FA}', iso2: 'VU', nsnLength: 7 },
    { name: 'Vatican', callingCode: '+379', flag: '\u{1F1FB}\u{1F1E6}', iso2: 'VA', nsnLength: 10 },
    { name: 'Venezuela', callingCode: '+58', flag: '\u{1F1FB}\u{1F1EA}', iso2: 'VE', nsnLength: 10 },
    { name: 'Viêt Nam', callingCode: '+84', flag: '\u{1F1FB}\u{1F1F3}', iso2: 'VN', nsnLength: 9 },
    { name: 'Yémen', callingCode: '+967', flag: '\u{1F1FE}\u{1F1EA}', iso2: 'YE', nsnLength: 9 },
    { name: 'Zambie', callingCode: '+260', flag: '\u{1F1FF}\u{1F1F2}', iso2: 'ZM', nsnLength: 9 },
    { name: 'Zimbabwe', callingCode: '+263', flag: '\u{1F1FF}\u{1F1FC}', iso2: 'ZW', nsnLength: 9 },
    // Territoires et dépendances
    { name: 'Guadeloupe', callingCode: '+590', flag: '\u{1F1EC}\u{1F1F5}', iso2: 'GP', nsnLength: 9 },
    {
        name: 'Guyane française',
        callingCode: '+594',
        flag: '\u{1F1EC}\u{1F1EB}',
        iso2: 'GF',
        nsnLength: 9,
    },
    { name: 'Hong Kong', callingCode: '+852', flag: '\u{1F1ED}\u{1F1F0}', iso2: 'HK', nsnLength: 8 },
    {
        name: 'Îles Marshall',
        callingCode: '+692',
        flag: '\u{1F1F2}\u{1F1ED}',
        iso2: 'MH',
        nsnLength: 7,
    },
    { name: 'Macao', callingCode: '+853', flag: '\u{1F1F2}\u{1F1F4}', iso2: 'MO', nsnLength: 8 },
    { name: 'Martinique', callingCode: '+596', flag: '\u{1F1F2}\u{1F1F6}', iso2: 'MQ', nsnLength: 9 },
    { name: 'Mayotte', callingCode: '+262', flag: '\u{1F1FE}\u{1F1F9}', iso2: 'YT', nsnLength: 9 },
    {
        name: 'Nouvelle-Calédonie',
        callingCode: '+687',
        flag: '\u{1F1F3}\u{1F1E8}',
        iso2: 'NC',
        nsnLength: 6,
    },
    {
        name: 'Polynésie française',
        callingCode: '+689',
        flag: '\u{1F1F5}\u{1F1EB}',
        iso2: 'PF',
        nsnLength: 6,
    },
    {
        name: 'Porto Rico',
        callingCode: '+1787',
        flag: '\u{1F1F5}\u{1F1F7}',
        iso2: 'PR',
        nsnLength: 7,
    },
    {
        name: 'Saint-Martin',
        callingCode: '+590',
        flag: '\u{1F1F2}\u{1F1EB}',
        iso2: 'MF',
        nsnLength: 9,
    },
    { name: 'Taïwan', callingCode: '+886', flag: '\u{1F1F9}\u{1F1FC}', iso2: 'TW', nsnLength: 9 },
    {
        name: 'Wallis-et-Futuna',
        callingCode: '+681',
        flag: '\u{1F1FC}\u{1F1EB}',
        iso2: 'WF',
        nsnLength: 6,
    },
    { name: 'Kosovo', callingCode: '+383', flag: '\u{1F1FD}\u{1F1F0}', iso2: 'XK', nsnLength: 8 },
    { name: 'Curaçao', callingCode: '+599', flag: '\u{1F1E8}\u{1F1FC}', iso2: 'CW', nsnLength: 7 },
    { name: 'Bermudes', callingCode: '+1441', flag: '\u{1F1E7}\u{1F1F2}', iso2: 'BM', nsnLength: 7 },
    {
        name: 'Îles Caïmans',
        callingCode: '+1345',
        flag: '\u{1F1F0}\u{1F1FE}',
        iso2: 'KY',
        nsnLength: 7,
    },
    {
        name: 'Îles Vierges américaines',
        callingCode: '+1340',
        flag: '\u{1F1FB}\u{1F1EE}',
        iso2: 'VI',
        nsnLength: 7,
    },
    {
        name: 'Îles Vierges britanniques',
        callingCode: '+1284',
        flag: '\u{1F1FB}\u{1F1EC}',
        iso2: 'VG',
        nsnLength: 7,
    },
    { name: 'Gibraltar', callingCode: '+350', flag: '\u{1F1EC}\u{1F1EE}', iso2: 'GI', nsnLength: 8 },
    { name: 'Guernesey', callingCode: '+44', flag: '\u{1F1EC}\u{1F1EC}', iso2: 'GG', nsnLength: 10 },
    { name: 'Jersey', callingCode: '+44', flag: '\u{1F1EF}\u{1F1EA}', iso2: 'JE', nsnLength: 10 },
    { name: 'Île de Man', callingCode: '+44', flag: '\u{1F1EE}\u{1F1F2}', iso2: 'IM', nsnLength: 10 },
    { name: 'Îles Féroé', callingCode: '+298', flag: '\u{1F1EB}\u{1F1F4}', iso2: 'FO', nsnLength: 6 },
    { name: 'Groenland', callingCode: '+299', flag: '\u{1F1EC}\u{1F1F1}', iso2: 'GL', nsnLength: 6 },
    { name: 'Aruba', callingCode: '+297', flag: '\u{1F1E6}\u{1F1FC}', iso2: 'AW', nsnLength: 7 },
    {
        name: 'Saint-Barthélemy',
        callingCode: '+590',
        flag: '\u{1F1E7}\u{1F1F1}',
        iso2: 'BL',
        nsnLength: 9,
    },
    {
        name: 'Îles Turques-et-Caïques',
        callingCode: '+1649',
        flag: '\u{1F1F9}\u{1F1E8}',
        iso2: 'TC',
        nsnLength: 7,
    },
    { name: 'Anguilla', callingCode: '+1264', flag: '\u{1F1E6}\u{1F1EE}', iso2: 'AI', nsnLength: 7 },
    {
        name: 'Montserrat',
        callingCode: '+1664',
        flag: '\u{1F1F2}\u{1F1F8}',
        iso2: 'MS',
        nsnLength: 7,
    },
    {
        name: 'Samoa américaines',
        callingCode: '+1684',
        flag: '\u{1F1E6}\u{1F1F8}',
        iso2: 'AS',
        nsnLength: 7,
    },
    { name: 'Guam', callingCode: '+1671', flag: '\u{1F1EC}\u{1F1FA}', iso2: 'GU', nsnLength: 7 },
    {
        name: 'Îles Mariannes du Nord',
        callingCode: '+1670',
        flag: '\u{1F1F2}\u{1F1F5}',
        iso2: 'MP',
        nsnLength: 7,
    },
    {
        name: 'Saint-Pierre-et-Miquelon',
        callingCode: '+508',
        flag: '\u{1F1F5}\u{1F1F2}',
        iso2: 'PM',
        nsnLength: 6,
    },
    { name: 'Îles Cook', callingCode: '+682', flag: '\u{1F1E8}\u{1F1F0}', iso2: 'CK', nsnLength: 5 },
    { name: 'Niué', callingCode: '+683', flag: '\u{1F1F3}\u{1F1FA}', iso2: 'NU', nsnLength: 4 },
    { name: 'Tokelau', callingCode: '+690', flag: '\u{1F1F9}\u{1F1F0}', iso2: 'TK', nsnLength: 4 },
    {
        name: 'Îles Falkland',
        callingCode: '+500',
        flag: '\u{1F1EB}\u{1F1F0}',
        iso2: 'FK',
        nsnLength: 5,
    },
    {
        name: 'Sainte-Hélène',
        callingCode: '+290',
        flag: '\u{1F1F8}\u{1F1ED}',
        iso2: 'SH',
        nsnLength: 4,
    },
    { name: 'Norfolk', callingCode: '+672', flag: '\u{1F1F3}\u{1F1EB}', iso2: 'NF', nsnLength: 6 },
];
/** Indicatif par défaut (France) */
export const DEFAULT_COUNTRY_CODE = COUNTRY_CALLING_CODES[0];
/**
 * Liste triée par longueur d'indicatif décroissante, pour un parsing sans ambiguïté.
 * Utilisée par parsePhoneValue pour matcher le bon indicatif.
 */
export const COUNTRY_CALLING_CODES_BY_LENGTH = [...COUNTRY_CALLING_CODES].sort((a, b) => b.callingCode.length - a.callingCode.length);
/**
 * Valide un numéro de téléphone international.
 * Retourne un message d'erreur ou undefined si valide.
 */
export function validatePhoneNumber(value) {
    if (!value)
        return undefined;
    const country = COUNTRY_CALLING_CODES_BY_LENGTH.find((c) => value.startsWith(c.callingCode));
    if (!country)
        return 'Indicatif pays non reconnu';
    const nsn = value.slice(country.callingCode.length);
    if (!/^\d+$/.test(nsn))
        return 'Le numéro ne doit contenir que des chiffres';
    if (nsn.length !== country.nsnLength) {
        return `Le numéro doit contenir ${country.nsnLength} chiffres pour ${country.name}`;
    }
    return undefined;
}
